@if (!isSearching()) {
  <div class="sticky-header" #stickyHeader>
    <app-top-bar [title]="title()" [showHomeBtn]="showHomeBtn()"></app-top-bar>
  </div>
}

<div
  class="page"
  [class.has-bottom-bar]="showBottomBar()"
  [style.min-height]="pageMinHeight()"
>
     @if (logoUrl())
     {
        <div class="logo-box" [class.collapsed]="isSearching()">
          <div
            [style.background-image]="logoUrl()"
            class="logo"
          >
          </div>
        </div>
     }

    @if (isGridLayout()) {
      <app-super-section-grid [topBarHeight]="headerHeight()" (searchActiveChange)="isSearching.set($event)"> </app-super-section-grid>
    } @else {
      <app-super-section-list> </app-super-section-list>
    }

</div>

@if (showBottomBar()) {
  <app-bottom-bar></app-bottom-bar>
}
